// extracted by mini-css-extract-plugin
export var auctionCarousel = "Auction-module--auctionCarousel--9F8jV";
export var auctionDetailContainer = "Auction-module--auctionDetailContainer--Kf73u";
export var auctionGrid = "Auction-module--auctionGrid---qyHR";
export var auctionOtherWorks = "Auction-module--auctionOtherWorks--14Gf7";
export var auctionShareButton = "Auction-module--auctionShareButton--OIGBE";
export var auctionShareButtonContainer = "Auction-module--auctionShareButtonContainer--yLfct";
export var lotDetailsShowOnDesktop = "Auction-module--lotDetailsShowOnDesktop--VP92R";
export var lotDetailsShowOnMobile = "Auction-module--lotDetailsShowOnMobile--TxxrO";